const shadows = {
    small: "1px 1px 0px 0px #221c4633",
    medium: "2px 2px 0px 0px #221c4633",
    large: "4px 4px 0px 0px #221c4633",
    bottom: "0px -1px 8px 0px #221C4612",
    side: "1px 0px 8px 0px #221C4612",
};
export default shadows;
//# sourceMappingURL=shadows.js.map